/* global productiveBlocksFrontendLocalization */

import Bugsnag from '@bugsnag/js';

if (productiveBlocksFrontendLocalization?.releaseStage !== 'development') {
	Bugsnag.start({
		apiKey: productiveBlocksFrontendLocalization?.bugsnagApiKey,
		appVersion: productiveBlocksFrontendLocalization?.appVersion,
		releaseStage: productiveBlocksFrontendLocalization?.releaseStage,
	});
}
